import { useState } from "react";

import { Tab } from "@headlessui/react";

/* Data */
import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";
import { convertPriceOnString } from "common/priceConvert";

/* Components
 */
import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FaqsGroup from "components/molecules/FaqsGroup";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner/index.js";
import Faqs from "components/organisms/Faqs";
import Packages from "components/organisms/PackagesNews";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

import styleBtn from "components/molecules/CardPackage/Index.module.scss";

const CorporateSecretary = ({ dataJson, data }) => {
  const [screen, setScreen] = useState();

  useResizeScreenModified(setScreen);

  return (
    <>
      <Banner
        minHeightBanner=" min-h-[503px]"
        wave={
          <div className="col-12 absolute bottom-0 hidden lg:block ">
            <Img
              src="/assets/images/wave/curve_top-wave.svg"
              className="h-full w-full"
              width={516}
              wrapper={{
                className: "w-full h-full",
              }}
              height={420}
              alt="banner-img"
            />
          </div>
        }
        breadcrumbs={dataJson?.breadcrumbs}
        title="Intensive Paperwork Holding You Down? Our Corporate Secretarial Service Can Help With That"
        leftContent={
          <div className="mb-0 text-center lg:col-11 lg:mb-14 lg:text-left ">
            We make sure the only work you&lsquo;re swimming in is growing your
            business, not in a sea of documents. Keep up with all your filing
            obligations and never miss a deadline again.
          </div>
        }
        titleProps={{
          className:
            " xl:text-4xl mb-6   text-bbc-30px font-semibold  xl:leading-[50px] text-center lg:text-left",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-6"
        rightClassName="lg:col-6"
        rightContent={
          <Img
            src="/assets/images/sg/corporate-secretary/banner-sg-secretary.png"
            wrapper={{
              className: "bbc-banner-image-bottom-0 lg:max-w-[530px]",
            }}
            className=""
            width={657}
            height={524}
            alt="Singapore company secretarial service"
          />
        }
        bgColor="bg-bbc-country"
      ></Banner>
      <div className="bg-bbc-brand-100 pt-10 lg:pt-20">
        <div className="container">
          <div className="mb-10 pb-10 lg:mb-0">
            <Title className="title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6">
              Singapore Secretarial Service
            </Title>
            <p className="mb-6">
              By law, every company in Singapore must have at least one
              corporate secretary under the Companies Act 1967 who will take on
              admistrative duties.
            </p>
            <p>
              Our corporate secretaries will take care of neccessary filing
              obligations and act as a main point of contact for any future
              interactions your company may have with legislators.
            </p>
            <div className="mt-10">
              <div className="row items-center justify-between">
                <div className="lg:col-6">
                  <Title as="h3" className="bbc-title-30 text-2xl leading-9">
                    Faciliating meetings
                  </Title>
                  <p>
                    From AGM to board meetings, they make sure you&lsquo;re at
                    the right place and time.
                  </p>
                </div>
                <div className="text-center lg:col-6 lg:text-right">
                  {" "}
                  <Img
                    src="/assets/images/sg/corporate-secretary/service1-sg-secretary.png"
                    width={496}
                    height={406}
                    alt="facilitate company meeting"
                  />
                </div>
              </div>
            </div>
            <div className="mt-10">
              <div className="row flex-col-reverse items-center justify-start lg:flex-row">
                <div className="text-center lg:col-6 lg:text-left">
                  <Img
                    src="/assets/images/sg/corporate-secretary/service2-sg-secretary.png"
                    width={452}
                    height={417}
                    alt="update company information"
                  />
                </div>
                <div className="lg:col-6">
                  <Title as="h3" className="bbc-title-30 text-2xl leading-9">
                    Updating your information in the registers
                  </Title>
                  <p className="mb-6">
                    Whether it&lsquo;s a change in key personnel or simply a
                    letter in your company name, nothing goes unnoticed and gets
                    updated to the Register almost as they happen.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-0 lg:mt-10">
              <div className="row items-center justify-between ">
                <div className="lg:col-6">
                  <Title as="h3" className="bbc-title-30 text-2xl leading-9">
                    Ensuring that your company stay compliant
                  </Title>
                  <p className="mb-6 lg:mb-0">
                    You&lsquo;ll always be confident to know that there&lsquo;s
                    always someone behind the scenes in charge of safeguarding
                    your company from legal troubles.
                  </p>
                </div>
                <div className="text-center lg:col-6 lg:text-right">
                  <Img
                    src="/assets/images/sg/corporate-secretary/service3-sg-secretary.png"
                    width={504}
                    height={367}
                    alt="ensure compliance"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 mb-10 hidden lg:mb-20 lg:block">
        <Img
          src="/assets/images/wave/curve_bot-wave.svg"
          className="h-full w-full"
          width={516}
          wrapper={{
            className: "w-full h-full",
          }}
          height={420}
          alt="banner-img"
        />
      </div>
      <section>
        <div className="container">
          <div className="pb-10 lg:pb-20">
            <Packages
              {...dataJson.dataPackage}
              data={data?.packages.dataPackage || []}
              dataStatic={dataJson.dataPackage}
              title={"Pricing"}
              changePrice={true}
              tabBarClass="hidden"
              customCardColor={{
                text: [
                  "text-bbc-brand-500",
                  "text-bbc-brand-700",
                  "text-bbc-yellow-500",
                ],
                border: [
                  "lg:hover:border-bbc-brand-500",
                  "lg:hover:border-bbc-brand-700",
                  "lg:hover:border-bbc-yellow-500",
                ],
                button: [
                  `bg-bbc-brand-500 ${styleBtn.btnBlue}`,
                  `bg-bbc-brand-700 ${styleBtn.btnDarkBlue}`,
                  `bg-bbc-yellow-500 ${styleBtn.btnYellow}`,
                ],
              }}
            />
          </div>
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Non-routine Corporate Secretary Services
          </Title>
          <TabListNew
            data={dataJson.dataPricing.data.map((item) => item.tab)}
            activeTab={dataJson.dataPricing.activeTab}
            tabListClass={{
              display: "flex lg:justify-center",
              length: "w-full",
              padding: "px-1 py-3",
              border: "border-0",
              othersClass: "whitespace-nowrap overflow-x-auto mb-20 lg:mb-6",
            }}
            tabClass={{
              padding: "py-2 px-4 ",
              tabColor:
                "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
              othersClass: "mr-2 last:mr-0 font-medium",
            }}
          >
            <Tab.Panels>
              {dataJson.dataPricing.data.map((item, index) => {
                return (
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                    key={index}
                  >
                    <div className="shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block">
                      <table className=" text-left text-sm text-bbc-gray ">
                        <thead className="col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ">
                          <tr>
                            {item.table?.thead?.map((thead, index) => {
                              return (
                                <th
                                  key={index}
                                  className={`${thead.width} py-8 text-center font-semibold`}
                                >
                                  {thead.name}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {item.table?.tbody?.map((thead, index) => {
                            return (
                              <tr
                                key={index}
                                className=" bg-bbc-white even:bg-bbc-brand-100"
                              >
                                <th className="w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700">
                                  {thead.title}
                                </th>
                                <td
                                  className="relative w-4/6 py-6 
                                 before:absolute before:left-0 before:top-6 before:h-[calc(100%_-_48px)] before:w-[1px] before:bg-bbc-neutral-700 before:content-['']
                                 after:absolute after:right-0 after:top-6 after:h-[calc(100%_-_48px)] after:w-[1px] after:bg-bbc-neutral-700 after:content-['']"
                                >
                                  <p
                                    className="px-6"
                                    dangerouslySetInnerHTML={{
                                      __html: convertPriceOnString(
                                        thead.description
                                      ),
                                    }}
                                  />
                                </td>
                                <td className="w-1/6 px-4 py-6 text-center align-top ">
                                  {thead.pricing ? (
                                    <div
                                      className="list-disc font-semibold text-bbc-brand-700"
                                      dangerouslySetInnerHTML={{
                                        __html: convertPriceOnString(
                                          thead.pricing
                                        ),
                                      }}
                                    />
                                  ) : (
                                    <LinkRouter
                                      href="/contact-us"
                                      className="pl-4 font-semibold text-bbc-brand-700"
                                    >
                                      Contact us
                                    </LinkRouter>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 block lg:hidden">
                      {item.table?.tbody?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]"
                          >
                            <h5 className="border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600">
                              {item.title}
                            </h5>
                            <p
                              className="border-b border-bbc-neutral-500 py-6 px-7 text-center"
                              dangerouslySetInnerHTML={{
                                __html: convertPriceOnString(item.description),
                              }}
                            />

                            {item.pricing ? (
                              <div
                                className="list-inside list-disc py-4 pl-4 text-center font-semibold text-bbc-brand-700"
                                dangerouslySetInnerHTML={{
                                  __html: convertPriceOnString(item.pricing),
                                }}
                              ></div>
                            ) : (
                              <p className="py-4 pl-4 text-center">
                                <LinkRouter
                                  href="/contact-us"
                                  className="font-semibold text-bbc-brand-700 "
                                >
                                  Contact us
                                </LinkRouter>
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <p className="mt-4 text-sm italic">{item.note}</p>
                  </Tab.Panel>
                );
              })}
            </Tab.Panels>
          </TabListNew>
        </div>
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Tired of red tapes? Go blue today
          </Title>
          <p className=" m-auto text-center lg:col-8 ">
            We stay grounded with compliance matters so you can be free to live
            that entrepreneur life. Sit back and let everything get taken care
            of in the background.
          </p>
          <div className="row mt-10 justify-between">
            <div className="mt-6 flex items-center lg:col-5">
              {screen === "DESKTOP" ? (
                <FaqsGroup data={dataJson.dataProactive} buttonClass="!pl-0" />
              ) : (
                <ul>
                  {dataJson.dataProactive.map((item, index) => (
                    <li key={index} className="mx-4 mb-10 text-center">
                      <div
                        className="mb-4"
                        dangerouslySetInnerHTML={{ __html: item.name }}
                      />
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="order-first lg:col-6 lg:order-last ">
              <Img
                src="/assets/images/sg/corporate-secretary/service4-sg-secretary.png"
                width={539}
                height={422}
                alt="why choose our Singapore company secretary service"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
              What customers say about BBCIncorp
            </Title>
            <p className="text-center">
              Our skillful secretary have helped thousands of businesses like
              yours with their corporate governance.
            </p>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <div className="mb-10 lg:mb-0">
        <div className="container">
          <div className="mx-auto lg:col-10">
            <Faqs data={dataJson.dataFaqs} description={" "} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateSecretary;
